import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import ContentRow from '../components/ContentRow';
import ContentModal from '../components/ContentModal';
import Footer from '../components/Footer';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BrowsePage() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const category = searchParams.get('category');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalContentId, setModalContentId] = useState(null);
  const [modalSource, setModalSource] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        const params = {};
        if (type) params.type = type;
        if (category) params.category = category;
        const { data } = await axios.get(`${API}/contents`, { params, withCredentials: true });
        setItems(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [type, category]);

  const title = type === 'series' ? 'Séries' : type === 'movie' ? 'Films' : type === 'fiction' ? 'Fictions' : type === 'documentaire' ? 'Documentaires' : type === 'jeunesse' ? 'Jeunesse' : category ? category.charAt(0).toUpperCase() + category.slice(1) : 'Explorer';

  const openModal = (id, rect) => { setModalContentId(id); setModalSource(rect || null); };

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(180deg, #11041F 0%, #382C4E 100%)' }} data-testid="browse-page">
      <Header />
      <div className="pt-24 px-6 md:px-16 pb-20">
        <h1 className="text-2xl sm:text-3xl font-bold font-['Manrope'] text-white mb-8">
          {title}
        </h1>
        {loading ? (
          <div className="flex justify-center py-20">
            <div className="w-8 h-8 border-2 border-[#E9641A]/30 border-t-[#E9641A] rounded-full animate-spin" />
          </div>
        ) : items.length > 0 ? (
          <ContentRow title="" items={items} onOpenModal={openModal} />
        ) : (
          <p className="text-white/50 text-center py-20">Aucun contenu disponible</p>
        )}
      </div>
      <Footer />
      {modalContentId && (
        <ContentModal contentId={modalContentId} onClose={() => setModalContentId(null)} sourceRect={modalSource} />
      )}
    </div>
  );
}
